import React from 'react';

const MetaeroLoader = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px',
      backgroundColor: '#0f172a',
      borderRadius: '12px'
    }}>
      <div style={{
        fontSize: '24px',
        fontWeight: 'bold',
        letterSpacing: '.2rem',
        color: '#38bdf8',
        marginBottom: '16px'
      }}>
        METAERO
      </div>
      <div style={{
        width: '60px',
        height: '60px',
        border: '6px solid #334155',
        borderTop: '6px solid #3b82f6',
        borderRadius: '50%',
        animation: 'spin 1.2s linear infinite'
      }} />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default MetaeroLoader;
